import AssetAPIClient from '../helpers/AssetAPIClient'

const assetApi = new AssetAPIClient();

// make the request at start to improve loading speed
const documentsGroupsPromise = assetApi.getDocuments();
const membersPromise = assetApi.getMembers()

export async function fetchTeam() {
  const members = await membersPromise;
  const team = members.map(m => ({
    image: m.image.url,
    name: m.name,
    position: m.role,
    biography: m.biography,
  }));
  return team
}

export async function fetchDocs(){
  const documentsGroups = await documentsGroupsPromise;
  const documentsObj = {}

  const formatDocuments = d => ({
    name: d.name,
    link: d.file.url
  })

  documentsGroups.forEach(g => {
    documentsObj[g.name] = g.documents.map(formatDocuments)
  });

  return documentsObj
}
